export const ARTICLE_MEDIA_BUCKET = 'article-media';
export const ARTICLE_MEDIA_MAX_IMAGE_BYTES = 10 * 1024 * 1024;
export const ARTICLE_MEDIA_MAX_VIDEO_BYTES = 50 * 1024 * 1024;
export const ARTICLE_MEDIA_IMAGE_MAX_WIDTH = 1920;
/** Max width before downscale; 2560 keeps 1440p/2K heroes sharp on large displays. */
export const ARTICLE_MEDIA_VIDEO_MAX_WIDTH = 2560;
/** x264 CRF — 18 is near visually lossless; only lower if storage budget allows. */
export const ARTICLE_MEDIA_VIDEO_CRF = 18;
/** x264 preset — slow maximizes detail per bit at the cost of longer encodes. */
export const ARTICLE_MEDIA_VIDEO_PRESET = 'slow';

export const ARTICLE_MEDIA_IMAGE_MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/gif',
] as const;

export const ARTICLE_MEDIA_VIDEO_MIME_TYPES = [
  'video/mp4',
  'video/webm',
  'video/quicktime',
] as const;

export function resolveArticleVideoInputExtension(mimeType: string): 'mp4' | 'webm' | 'mov' {
  if (mimeType === 'video/webm') return 'webm';
  if (mimeType === 'video/quicktime') return 'mov';
  return 'mp4';
}

/** File picker accept value for CMS hero video uploads. */
export const ARTICLE_MEDIA_VIDEO_FILE_ACCEPT = [
  ...ARTICLE_MEDIA_VIDEO_MIME_TYPES,
  '.mov',
].join(',');

export function buildArticleMediaStoragePath(filename: string): string {
  const safeName = filename.replace(/[^a-zA-Z0-9._-]+/g, '-').replace(/^-+|-+$/g, '');
  const stamp = Date.now();
  const random = Math.random().toString(36).slice(2, 10);
  return `uploads/${stamp}-${random}-${safeName || 'media'}`;
}
